import { z } from 'zod';
/**
 * E3 — Preventiva e quilometragem (RF-10 a RF-13, RF-25).
 *
 * A jornada do PRD (6.2): o sistema projeta o km diariamente, antecipa a
 * janela quando o carro roda acima do previsto, o PCM monta o escopo somando
 * o pacote vigente ao backlog do carro, o Estoque separa o kit em D-1 e a
 * Manutenção reserva a equipe. O carro só sai da escala com tudo confirmado
 * (RN-10); pendência dispara reprogramação com motivo (RF-13).
 */
export const ScheduleStatus = {
    PLANNED: 'PLANNED',
    CONFIRMED: 'CONFIRMED',
    IN_EXECUTION: 'IN_EXECUTION',
    DONE: 'DONE',
    RESCHEDULED: 'RESCHEDULED',
    CANCELLED: 'CANCELLED',
};
export const SCHEDULE_STATUS_LABELS = {
    PLANNED: 'Planejada',
    CONFIRMED: 'Confirmada',
    IN_EXECUTION: 'Em execução',
    DONE: 'Concluída',
    RESCHEDULED: 'Reprogramada',
    CANCELLED: 'Cancelada',
};
export const KitSeparationStatus = {
    PENDING: 'PENDING',
    SEPARATED: 'SEPARATED',
    CONFIRMED: 'CONFIRMED',
    CANCELLED: 'CANCELLED',
};
export const KIT_STATUS_LABELS = {
    PENDING: 'Kit pendente',
    SEPARATED: 'Kit separado',
    CONFIRMED: 'Kit confirmado',
    CANCELLED: 'Kit cancelado',
};
/**
 * Quantos km antes da janela o sistema começa a avisar. O PRD fala em
 * "antecipar a janela quando o carro roda acima do previsto" (RF-10).
 * ARBITRADO: 1.000 km, a validar com o PCM.
 */
export const WINDOW_ALERT_KM = 1_000;
/** Dias de antecedência para o kit (RF-25: D-1). */
export const KIT_LEAD_DAYS = 1;
// --- Entrada -----------------------------------------------------------------
export const createScheduleSchema = z.object({
    vehicleId: z.string().uuid('Selecione o carro'),
    packageId: z.string().uuid('Selecione o pacote'),
    /** Km em que a janela vence. Sugerido pela linha do tempo; o PCM pode ajustar. */
    targetKm: z.coerce.number().int().positive(),
    plannedDate: z.coerce.date().optional(),
    /** Itens do backlog do carro que entram no escopo desta parada (RF-11). */
    backlogItemIds: z.array(z.string().uuid()).default([]),
    kitId: z.string().uuid().optional(),
});
export const rescheduleSchema = z.object({
    toDate: z.coerce.date({ message: 'Informe a nova data' }),
    /** RF-13 — reprogramação sempre com código de motivo. */
    reasonCodeId: z.string().uuid({ message: 'Selecione o motivo' }),
    note: z.string().trim().max(255).optional(),
});
export const reserveTeamSchema = z.object({
    specialtyId: z.string().uuid('Selecione a especialidade'),
    headcount: z.coerce.number().int().min(1).max(20).default(1),
});
export const scheduleQuerySchema = z.object({
    status: z.nativeEnum(ScheduleStatus).optional(),
    vehicleId: z.string().uuid().optional(),
    /** Só o que ainda não aconteceu. */
    upcoming: z.coerce.boolean().default(true),
});
//# sourceMappingURL=scheduling.schemas.js.map